export default __webpack_public_path__ + "static/media/47SJ66.c622459b.png";